export default "__VITE_ASSET__VBWjuHMR__"